module.exports = __webpack_public_path__ + "img/slowDown_choosed.58a37c71.png";